import _defineProperty from "/home/buildagent/buildAgent/work/35e0d48fca3726c0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import isServer from '../is/isServer';
export var getDomain = function getDomain() {
  return isLocal() ? location.hostname : location.hostname.replace(/\w\w\w\.|^/, '.');
};
export var getExpireDate = function getExpireDate(days) {
  var date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  return date.toUTCString();
};

var toCookie = function toCookie(props) {
  return Object.keys(props).reduce(function (acc, key) {
    var value = props[key] === true ? '' : "=".concat(props[key]);
    return "".concat(acc).concat(key).concat(value, ";");
  }, '');
};

export var get = function get(name, originCookie) {
  var browserCookie = isServer() ? '' : document.cookie;
  var cookie = "; ".concat(originCookie || browserCookie);
  var parts = cookie.split("; ".concat(name, "="));

  if (parts.length === 2) {
    var value = parts.pop() || '';
    return value.replace('=', '').split(';').shift();
  }
};
export var remove = function remove(name, domain) {
  var _toCookie;

  if (isServer()) return;
  document.cookie = toCookie((_toCookie = {}, _defineProperty(_toCookie, name, ''), _defineProperty(_toCookie, "path", '/'), _defineProperty(_toCookie, "domain", domain || getDomain()), _defineProperty(_toCookie, "expires", 'Thu, 01 Jan 1970 00:00:01 GMT'), _toCookie));
};

var isLocal = function isLocal() {
  return location.hostname === 'localhost';
};

export var set = function set(name) {
  var _objectSpread2;

  var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var expireDays = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;
  var domain = arguments.length > 3 ? arguments[3] : undefined;
  if (isServer()) return;
  document.cookie = toCookie(_objectSpread((_objectSpread2 = {}, _defineProperty(_objectSpread2, name, value), _defineProperty(_objectSpread2, "path", '/'), _defineProperty(_objectSpread2, "domain", domain || getDomain()), _defineProperty(_objectSpread2, "expires", getExpireDate(expireDays)), _objectSpread2), !isLocal() && {
    SameSite: 'None',
    Secure: true
  }));
};